import { render } from "./PortfolioHome.vue?vue&type=template&id=074e0e18&scoped=true"
import script from "./PortfolioHome.vue?vue&type=script&lang=js"
export * from "./PortfolioHome.vue?vue&type=script&lang=js"

import "./PortfolioHome.vue?vue&type=style&index=0&id=074e0e18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074e0e18"]])

export default __exports__